import React from "react";

const AppML_Case_Employees = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Employees</h1>
      <p>This is the AppML Case Employees page content.</p>
    </div>
  );
};

export default AppML_Case_Employees;
